import styled from 'styled-components/macro';
import { CustomScroll } from '@yme/atoms/custom-scroll';
import { RegularTextLevel3 } from '@yme/tokens/typography';
export const SubtitleStyled = styled(RegularTextLevel3) `
  margin-top: 24px;
`;
export const OptionsWrapperStyled = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 24px;
  gap: 16px;

  ${CustomScroll};

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}

  max-height: 224px;
  padding-right: 0;
  border: none;
`;
